
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.15 1.282a5.486 5.486 0 014.345 0 5.668 5.668 0 011.842 1.277 5.912 5.912 0 011.23 1.911 6.095 6.095 0 010 4.51 5.91 5.91 0 01-1.23 1.91l-7.72 8.011a.851.851 0 01-1.235 0l-7.72-8.01a6.05 6.05 0 010-8.332 5.532 5.532 0 018.03 0l.308.32.308-.32a5.669 5.669 0 011.842-1.277z"}})])
          )
        }
      }
    